import { buildApiUrl, buildAssetUrl } from '../../utils/api';

const normalizeSearchResult = (product) => ({
  ...product,
  id: product.product_id ?? product.id,
  product_id: product.product_id ?? product.id,
  name: product.name ?? product.product_name ?? 'Product',
  product_name: product.product_name ?? product.name ?? 'Product',
  image: buildAssetUrl(product.image ?? product.product_image ?? product.image1 ?? null),
  category_name: product.category_name ?? product.category ?? '',
  price: Number.parseFloat(product.price ?? product.starting_price ?? 0) || 0,
});

export const createSearchSlice = (set) => ({
  searchQuery: '',
  searchResults: [],
  searchLoading: false,
  searchError: null,

  setSearchQuery: (query) => set({ searchQuery: query }),

  searchProducts: async (query, limit = 10) => {
    if (!query || query.trim().length < 2) {
      set({ searchResults: [], searchLoading: false });
      return;
    }

    set({ searchLoading: true, searchError: null });
    try {
      const res = await fetch(buildApiUrl(`api/v1/customer/products/search?q=${encodeURIComponent(query)}&limit=${limit}`), {
        headers: { 'Content-Type': 'application/json' },
      });
      const json = await res.json();
      if (!res.ok || !json.success) throw new Error(json.message || 'Search failed');
      set({ searchResults: (json.data || []).map(normalizeSearchResult), searchLoading: false });
    } catch (err) {
      set({ searchError: err.message, searchLoading: false, searchResults: [] });
    }
  },

  clearSearch: () => set({ searchQuery: '', searchResults: [], searchError: null }),
});
